import React from "react";
import _ from "lodash";

const ChoiceSelector = React.memo(({ children, selectedChoice, setChoice, className, style }) => {
    return <div className={className} style={style}>
        {children.map(child => {
            if (!child) return;
            return React.cloneElement(child, {
                key: child.props.choiceKey,
                isSelected: child.props.choiceKey === selectedChoice,
                setSelected: () => setChoice(child.props.choiceKey),
                hasSelection: !_.isNil(selectedChoice)
            });
        })}
    </div>
});

export default ChoiceSelector;